// extracted by mini-css-extract-plugin
export default {"messageBtn":"PopupMessageSenderV2_messageBtn__Lf9KM"};